export default ($compile) => ({
    restrict: 'A',
    replace: true,
    link(scope, element, attrs) {
        scope.$watch(attrs.ngBindHtmlCompile, function(html = '<null/>') {
            element[0].innerHTML = html;
            $compile(element.contents())(scope);
        });
    }
});